export default class {
  constructor() {
    this.btn = 'hamburger';
  }

  init() {
    $(() => {
      const menuButton = document.getElementById(this.btn);
      const body = document.getElementsByTagName('body')[0];
      menuButton.addEventListener('click', (e) => {
        e.preventDefault();
        if (!menuButton.classList.contains('is-active')) {
          menuButton.classList.add('is-active');
          body.classList.add('menu-open');
        } else {
          menuButton.classList.remove('is-active');
          body.classList.remove('menu-open');
        }
      });
    });
  }
};
